import { Link } from "react-router-dom";

const COMPANY = "Hephy 3D";
const EMAIL = "hephesteus3d@gmail.com";
const SITE = "https://hephy3d.com";
const UPDATED = "8 de agosto de 2026";

const NAV = [
  ["/privacy", "Privacidad"],
  ["/terms", "Términos"],
  ["/data-deletion", "Eliminación de datos"],
  ["/cookies", "Cookies"],
  ["/pricing", "Precios"],
  ["/contact", "Contacto"],
];

export default function LegalLayout({ title, children }) {
  return (
    <div className="min-h-screen bg-obsidian text-neutral-200" data-testid="legal-page">
      <header className="border-b border-white/10">
        <div className="max-w-3xl mx-auto px-6 py-5 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2" data-testid="legal-home-link">
            <img src="/hephy-logo.png" alt="Hephy 3D" className="h-8 w-8" />
            <span className="font-serif text-lg">Hephy 3D</span>
          </Link>
          <Link to="/" className="text-sm text-neutral-400 hover:text-gold">← Inicio</Link>
        </div>
      </header>
      <main className="max-w-3xl mx-auto px-6 py-12">
        <h1 className="font-serif text-3xl sm:text-4xl mb-2">{title}</h1>
        <p className="text-sm text-neutral-500 mb-8">Última actualización: {UPDATED} · {COMPANY} · Estados Unidos</p>
        <div className="prose-legal space-y-5 text-[15px] leading-relaxed text-neutral-300 [&_h2]:text-white [&_h2]:font-semibold [&_h2]:text-xl [&_h2]:mt-8 [&_h2]:mb-2 [&_a]:text-gold [&_ul]:list-disc [&_ul]:pl-6 [&_ul]:space-y-1">
          {children}
        </div>
      </main>
      <footer className="border-t border-white/10 mt-8">
        <div className="max-w-3xl mx-auto px-6 py-8">
          <div className="flex flex-wrap gap-x-5 gap-y-2 text-sm text-neutral-400">
            {NAV.map(([to, label]) => (
              <Link key={to} to={to} className="hover:text-gold" data-testid={`legal-nav-${to.slice(1)}`}>{label}</Link>
            ))}
          </div>
          <p className="text-xs text-neutral-600 mt-4">© {new Date().getFullYear()} {COMPANY}. Todos los derechos reservados. · <a href={`mailto:${EMAIL}`} className="text-neutral-500 hover:text-gold">{EMAIL}</a> · <a href={SITE} className="text-neutral-500 hover:text-gold">{SITE}</a></p>
        </div>
      </footer>
    </div>
  );
}

export { COMPANY, EMAIL, SITE };
